// @ts-nocheck
/* eslint-disable */

import React, { useEffect } from 'react';
import { useBridgeState } from '@digitaz/bridge-sdk-client';
import { BannerName } from './Banners.types';
import { AdManagerBanners } from './Banners.constants';
import { adjustBackgroundBannerOffset } from './Banners.helpers';
import NoSsr from '@/components/NoSsr/NoSsr';

export interface Props {
  bannerName: BannerName;
}

export const AdManagerBanner = ({ bannerName }: Props) => {
  const { isWebView } = useBridgeState();

  useEffect(() => {
    if (isWebView) return;

    const googletag = window.googletag || (window.googletag = { cmd: [] });

    googletag.cmd.push(() => {
      const bannerConfig = AdManagerBanners[bannerName];

      const existingSlots = googletag.pubads().getSlots();
      const existingSlot = existingSlots.find(
        slot => slot.getSlotElementId() === bannerConfig.blockId
      );

      if (existingSlot) {
        googletag.destroySlots([existingSlot]);
      }

      const slot = googletag.defineSlot(
        bannerConfig.bannerId,
        bannerConfig.sizes,
        bannerConfig.blockId
      );

      if (slot) {
        slot.addService(googletag.pubads());
        googletag.enableServices();
      }
    });

    setTimeout(() => {
      googletag.cmd.push(() => {
        googletag.display(AdManagerBanners[bannerName].blockId);

        if (
          bannerName.includes(BannerName.Background) ||
          bannerName === BannerName.Top ||
          bannerName === BannerName.TopDesktop
        ) {
          adjustBackgroundBannerOffset();
        }
      });
    }, 0);
  }, [bannerName]);

  return (
    <NoSsr>
      <div
        className={AdManagerBanners[bannerName].blockId}
        id={AdManagerBanners[bannerName].blockId}
      />
    </NoSsr>
  );
};
